import { dollars } from 'src/utils/stringHelpers';

export const NO_PRE_BIDS_LABEL = 'NO PRE-BIDS';

// highBid is a GraphQL Decimal (string) and settles at 0 rather than null when
// a lot has no bids yet; highPreBidPrice is an Int and stays null until someone
// pre-bids.
const positiveAmount = value => {
  const amount = parseFloat(value);
  return amount > 0 ? amount : null;
};

// Everything before the auctioneer opens the lot is a pre-bid, so the label
// follows the figure's source rather than the card's sale window.
export const currentBidLabel = asset => {
  const saleAsset = asset?.activeSaleAsset;
  const liveBid = saleAsset && positiveAmount(saleAsset.highBid);
  const preBid = saleAsset && positiveAmount(saleAsset.highPreBidPrice);

  if (liveBid) { return `CURRENT BID: ${dollars(liveBid)}`; }
  if (preBid) { return `CURRENT PRE-BID: ${dollars(preBid)}`; }

  return NO_PRE_BIDS_LABEL;
};
